import AppHeader from '../AppHeader'

export default {
  name: 'normal-question-detail',
  created () {
    this.search()
  },
  data () {
    return {
      title: '',
      questions: [
        {content: null, displayOrder: 1}
      ],
      canValidate: true
    }
  },
  computed: {
    validation: function () {
      var v = {
        title: !!this.title,

        not_input: !!this.title
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      this.$store.dispatch('GET_NORMAL_QUESTION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        this.title = res.title.title
        if (res.question_details.length > 0) {
          this.questions = res.question_details
        }
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/normal_question')
    },
    newLineContent: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/normal-question-detail.js